<template>
  <div id="lrealtime">
    <DeviceInfo ref="deviceInfo"
                :data="deviceInfo"></DeviceInfo>
  </div>
</template>

<script>
import DeviceInfo from '@/components/DeviceInfo'
export default {
  name: 'lrealtime',
  components: { DeviceInfo },
  props: {
    uid: {
      type: String,
      default: () => { return '' }
    },
    devices: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      deviceInfo: {}
    }
  },
  watch: {
    uid: {
      handler () {
        this.getData()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () { },
  methods: {
    getData () {
      let device = this.common.cFindObj(this.devices, "id", this.uid);
      if (device != null) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.deviceInfo = device;
            this.$refs.deviceInfo.setChartData();
          }, 100);
        })
      }
    }
  }
}
</script>

<style lang="scss">
</style>